import {
  ImportExamineeAnswersButton,
  useExamEventDetails,
} from '@exam-center/exam-event-management';
import { ExamType } from '@exam-center/graphql';
import { dayjs } from '@shared/utils';

import { EmptyExamEventResultOverlay } from '../../components';
export default function EmptyExamEventResultSection() {
  const {
    examEvent: { id: examEventId, examType, examEndedAt },
  } = useExamEventDetails();

  switch (examType) {
    case ExamType.Paper: {
      const examEndedAtDateTime = dayjs(examEndedAt);
      const canImportAnswers =
        examEndedAtDateTime.isValid() && dayjs().isAfter(examEndedAtDateTime);

      return (
        <EmptyExamEventResultOverlay
          subTitle='กรุณาอัปโหลดไฟล์กระดาษคำตอบเพื่อเริ่มการตรวจข้อสอบ'
          endAdornment={
            <ImportExamineeAnswersButton disabled={!canImportAnswers} examEventId={examEventId} />
          }
        />
      );
    }
    case ExamType.Computer:
    default:
      return (
        <EmptyExamEventResultOverlay subTitle='ระบบจะแสดงผลการสอบหลังจากการสอบในรอบนี้เสร็จสิ้นแล้ว' />
      );
  }
}
